import styled from "styled-components";
import { GizmoContainerResize } from "../../utils";

const Chart = styled(GizmoContainerResize)``;

export { Chart };
